import { AccountClosureModal } from '@viastud/ui/shared/account-closure-modal'
import { useShallow } from 'zustand/shallow'

import { useAuthStore } from '@/store/auth.store'

export const DeleteProfileModal = ({ id }: { id: string }) => {
  const { updateAuth } = useAuthStore(
    useShallow((state) => ({
      updateAuth: state.updateAuth,
    }))
  )

  return (
    <AccountClosureModal
      id={id}
      self
      onClosed={() => {
        updateAuth({ user: undefined, role: null, isAuthenticated: false })
      }}
    />
  )
}
